import InfluencerSearchPage from './dumb.js';
import enhance from './enhancer';

export default enhance(InfluencerSearchPage);
